module.exports = [
	{
		"scene": {
			"id": 1,
			"width": "100%",
			"height": "700",
			"image": "../images/s1.jpeg",
			"is_stereo": false,
			"is_debug": false,
			"is_vr_off": true,
			"hide_fullscreen_button": true,
			"title": "Scene 1. Initial Scene",
			"description": "<div>• Hotspot (1) → Scene (2)</div><div>• Hotspot (2) → No scene defined</div><div>• Hotspot (3) → Execute Function</div>"
		},
		"hotspots": [
			{
				"name": "scene1-hotspot1",
				"pitch": 0,
				"yaw": 0,
				"radius": 0.05,
				"distance": 2,
				"idNewScene": 2
			}
		]
	},
	{
		"scene": {
			"id": 2,
			"width": "100%",
			"height": "700",
			"image": "../images/s2.jpeg",
			"is_stereo": false,
			"is_debug": false,
			"is_vr_off": true,
			"hide_fullscreen_button": true,
			"title": "Scene 2. Inside Store",
			"description": "<div>• Hotspot (1) → Scene (2)</div><div>• Hotspot (2) → No scene defined</div><div>• Hotspot (3) → Execute Function</div>"
		},
		"hotspots": [
			{
				"name": "scene2-hotspot1",
				"pitch": 10,
				"yaw": 23,
				"radius": 0.02,
				"distance": 1,
				"clickFn": "(window as any).handleClickHotspot3DModal()"
			},
			{
				"name": "scene2-hotspot2",
				"pitch": -18,
				"yaw": 51,
				"radius": 0.008,
				"distance": 0.4,
				"clickFn": "(window as any).handleClickHotspot3DModal()"
			}
		]
	},
	{
		"scene": {
			"id": 3,
			"is_debug": true,
			"image": "../images/landscape1.jpg",
			"is_stereo": false,
			"title": "Scene 2",
			"description": "<div>• Hotspot (3) → Scene (3)</div><div>• Hotspot (4) → Scene (4)</div>"
		},
		"hotspots": [
			{
				"name": "scene2-hotspot3",
				"pitch": 0,
				"yaw": 0,
				"radius": 0.05,
				"distance": 2,
				"idNewScene": 3
			},
			{
				"name": "scene2-hotspot4",
				"pitch": 0,
				"yaw": -35,
				"radius": 0.05,
				"distance": 2,
				"idNewScene": 4
			}
		]
	},
	{
		"scene": {
			"id": 4,
			"image": "../images/palmbeach.jpg",
			"is_stereo": false,
			"title": "Scene 3",
			"description": "<div>• Hotspot (5) → Scene (4)</div>"
		},
		"hotspots": [
			{
				"name": "scene3-hotspot5",
				"pitch": -10,
				"yaw": 0,
				"radius": 0.05,
				"distance": 2,
				"idNewScene": 4
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/scenes/scenes.json
// module id = 239
// module chunks = 0